export default __webpack_public_path__ + "static/media/pennybun5.92cbaa79.png";